
/**
 * 플랜 상태
 */
export type PlanResponse2Status = typeof PlanResponse2Status[keyof typeof PlanResponse2Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanResponse2Status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
